import { z } from "zod";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { agentArchSchema, agentOsSchema, agentUpdateChannelSchema } from "./enums.js";
/**
 * Ajan yayınları — PLATFORM düzeyi kayıt (RLS yok; tüm kiracıların ajanları aynı yayını indirir).
 *
 * İmza anahtarının ÖZEL kısmı SUNUCUDA DURMAZ: yayın aracı (`agent release sign`) manifesti çevrimdışı imzalar,
 * sunucu yalnızca `manifest + signature` ikilisini saklar, doğrular ve sunar. Doğrulama `AGENT_RELEASE_PUBLIC_KEYS`
 * ortam değişkenindeki (virgülle ayrılmış base64) açık anahtarlardan biriyle yapılır; env boşsa kayıt REDDEDİLİR.
 */
export const createAgentReleaseSchema = z.object({
    manifest: z.string().min(1).max(20_000).describe("base64: imzalanan manifest JSON baytları"),
    signature: z.string().min(1).max(200).describe("base64: ed25519(manifest baytları)"),
    isActive: z.boolean().default(true),
});
export const patchAgentReleaseSchema = z.object({ isActive: z.boolean() });
export const agentReleaseSchema = z.object({
    id: uuidSchema,
    version: z.string(),
    channel: agentUpdateChannelSchema,
    os: agentOsSchema,
    arch: agentArchSchema,
    url: z.string(),
    sha256: z.string(),
    sizeBytes: z.string().describe("bigint, dizge"),
    minVersion: z.string().nullable(),
    notes: z.string().nullable(),
    releasedAt: timestampSchema,
    isActive: z.boolean(),
    rolloutPercent: z.number().int().describe("Kademeli yayın yüzdesi (100 = tüm ajanlar)"),
    createdAt: timestampSchema,
});
export const agentReleaseListSchema = z.object({ items: z.array(agentReleaseSchema) });
export const listAgentReleasesQuerySchema = z.object({
    channel: agentUpdateChannelSchema.optional(),
    os: agentOsSchema.optional(),
    arch: agentArchSchema.optional(),
    activeOnly: z.coerce.boolean().optional(),
});
export const agentReleaseParamsSchema = z.object({ id: uuidSchema });
//# sourceMappingURL=releases.js.map